/** Les mots d'un message vocal réglable (`<MessageAttachment kind="voice">`) — purs. */

/** « 0:42 », « 12:05 » : la durée d'un vocal. Vide tant qu'elle n'est pas connue. */
export function formatVoiceDuration(seconds: number | null | undefined): string {
    if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return ""
    const total = Math.round(seconds)
    return `${Math.floor(total / 60)}:${String(total % 60).padStart(2, "0")}`
}

/** « 1x », « 1,5x », « 2x » — la vitesse écrite à la française (l'ancien lecteur écrivait « 1.5x »). */
export function voiceRateLabel(rate: number): string {
    return `${String(rate).replace(".", ",")}x`
}

/** « 0:12 / 0:42 » une fois la lecture placée, comme l'ancien lecteur ; la durée seule sinon. */
export function voiceTimeLabel(durationLabel: string, elapsedLabel: string | undefined): string {
    if (elapsedLabel == null || elapsedLabel === "" || durationLabel === "") return durationLabel
    return `${elapsedLabel} / ${durationLabel}`
}
